export default {
    computed: {
        budgetInEuro () {
            // 1 Code === 4 Hearts === 2 €
            // 1 Heart === 0.5 €
            return ((this.project.hearts_count / 2).toFixed(2) + '').replace('.', ',')
        },

        budgetTargetInEuro () {
            // 1 Code === 4 Hearts === 2 €
            // 1 Heart === 0.5 €
            return ((this.project.spendenziel / 2).toFixed(2) + '').replace('.', ',')
        },

        budgetPercent () {
            return Math.round(this.project.hearts_count / this.project.spendenziel * 100)
        },

        budgetInfoBarStyle () {
            return `width: ${this.budgetPercent}%;`
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/ProjectBudget.js